import { render, staticRenderFns } from "./IncommingCallWrapper.vue?vue&type=template&id=4873250f&scoped=true&lang=pug&"
import script from "./IncommingCallWrapper.vue?vue&type=script&lang=js&"
export * from "./IncommingCallWrapper.vue?vue&type=script&lang=js&"
import style0 from "./IncommingCallWrapper.vue?vue&type=style&index=0&id=4873250f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4873250f",
  null
  
)

export default component.exports